var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.ExportByCustomer"),
            visible: _vm.showExportByCustomerWindow,
            width: "800px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showExportByCustomerWindow = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "exportCustomerRef",
                  attrs: {
                    model: _vm.queryForm,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("GlobalSetObj.client"),
                                prop: "customerId",
                                rules: [
                                  {
                                    required: true,
                                    message: _vm.$t("collectionCenter.notNull"),
                                    trigger: ["blur", "change"],
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    "remote-method": _vm.getCustomerPage,
                                    clearable: "",
                                    filterable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                  },
                                  on: {
                                    "visible-change": _vm.changeCustomerPage,
                                  },
                                  model: {
                                    value: _vm.queryForm.customerId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryForm, "customerId", $$v)
                                    },
                                    expression: "queryForm.customerId",
                                  },
                                },
                                _vm._l(_vm.customerList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label:
                                        item.customerAlias +
                                        "（" +
                                        item.username +
                                        "）",
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("GlobalSetObj.InvoicingTime"),
                                prop: "invoiceIssueTime",
                                rules: [
                                  {
                                    required: true,
                                    message: _vm.$t("collectionCenter.notNull"),
                                    trigger: ["blur", "change"],
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "datetimerange",
                                  "range-separator": "-",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  "default-time": ["00:00:00", "23:59:59"],
                                  "start-placeholder": _vm.$t(
                                    "GlobalSetObj.startDate"
                                  ),
                                  "end-placeholder": _vm.$t(
                                    "GlobalSetObj.endDate"
                                  ),
                                  "picker-options": _vm.pickerOptions,
                                },
                                model: {
                                  value: _vm.queryForm.invoiceIssueTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm,
                                      "invoiceIssueTime",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.invoiceIssueTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.clickExportByCustomer },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.export")))]
              ),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.closeWindow } },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }